module.exports = __webpack_public_path__ + "static/img/iconfont.9bbe6d0e.svg";